import React, { PureComponent, Fragment } from 'react';
import MediaQuery from 'react-responsive';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

const {
  apiFetch,
  i18n: {
    __,
  },
} = wp;

// eslint-disable-next-line id-length, space-unary-ops, max-len
export const sortAlerts = (alerts) => alerts.sort((a, b) => a.severity - b.severity);

class WeatherAlerts extends PureComponent {
  state = {
    alerts: [],
    closings: [],
  };

  componentDidMount() {
    this.fetchAlerts();
  }

  fetchAlerts() {
    Promise.all([
      apiFetch({
        path: '/nbc/v1/weather-alerts',
      }),
      apiFetch({
        path: '/nbc/v1/school-closings',
      }),
    ])
      .then((values) => {
        const [alerts, closings] = values;
        this.setState({
          alerts: sortAlerts(alerts),
          closings,
        });
      });
  }

  renderAlertNotice() {
    const {
      state: {
        alerts,
      },
    } = this;

    const {
      weather: {
        alerts_url: alertsUrl,
      },
    } = nbc;

    return (
      <div className="weather-alerts-notice">
        <a href={alertsUrl}>
          <span className="weather-alerts-notice__count">
            {alerts.length}
          </span>
          <div className="weather-alerts-notice__label-wrap">
            <span className="weather-alerts-notice__label">
              {__('Weather Alerts', 'nbc')}
            </span>
            <span className="weather-alerts-notice__view-all">
              {__('View All', 'nbc')}
            </span>
          </div>
        </a>
      </div>
    );
  }

  renderClosingsNotice() {
    const {
      state: {
        closings,
      },
    } = this;

    const {
      weather: {
        closings_url: closingsUrl,
      },
    } = nbc;

    return (
      <div className="weather-alerts-notice">
        <a href={closingsUrl}>
          <span className="weather-alerts-notice__count">
            {closings.length}
          </span>
          <div className="weather-alerts-notice__label-wrap">
            <span className="weather-alerts-notice__label">
              {__('School Closings', 'nbc')}
            </span>
            <span className="weather-alerts-notice__view-all">
              {__('View All', 'nbc')}
            </span>
          </div>
        </a>
      </div>
    );
  }

  renderAlertsCarousel() {
    const {
      state: {
        alerts,
        closings,
      },
    } = this;

    const {
      weather: {
        alerts_url: alertsUrl,
      },
    } = nbc;

    const settings = {
      dots: false,
      arrows: true,
      infinite: false,
      draggable: true,
      swipeToSlide: true,
    };

    const renderAlert = (alert) => (
      <div key={alert.bulletin}>
        <a
          href={alertsUrl}
          className={`weather-alerts-slider__item severity-${alert.severity}`}
        >
          <span className="weather-alerts-slider__item-type">
            {alert.headline}
          </span>
          <span className="weather-alerts-slider__item-location">
            {`${alert.city_name}, ${alert.state_abbr}`}
          </span>
        </a>
      </div>
    );

    const getSlideSettings = (schoolClosings, slideCount) => {
      let newSlideCount = slideCount;

      // Show an additional alert if there are no school closings.
      if (! schoolClosings.length) {
        newSlideCount = slideCount + 1;
      }

      return {
        ...settings,
        slidesToShow: newSlideCount,
        slidesToScroll: newSlideCount,
      };
    };

    return (
      <div
        // eslint-disable-next-line max-len
        className={`weather-alerts-slider weather-alerts-slider--${closings.length ? 'with-closings' : 'without-closings'}`}
      >
        <MediaQuery minWidth={1024} maxWidth={1099}>
          <Slider {...getSlideSettings(closings, 3)}>
            {alerts.map(renderAlert)}
          </Slider>
        </MediaQuery>
        <MediaQuery minWidth={1100} maxWidth={1279}>
          <Slider {...getSlideSettings(closings, 4)}>
            {alerts.map(renderAlert)}
          </Slider>
        </MediaQuery>
        <MediaQuery minWidth={1280} maxWidth={1439}>
          <Slider {...getSlideSettings(closings, 5)}>
            {alerts.map(renderAlert)}
          </Slider>
        </MediaQuery>
        <MediaQuery minWidth={1440}>
          <Slider {...getSlideSettings(closings, 6)}>
            {alerts.map(renderAlert)}
          </Slider>
        </MediaQuery>
      </div>
    );
  }

  render() {
    const {
      state: {
        alerts,
        closings,
      },
    } = this;

    if (! alerts.length && ! closings.length) {
      return null;
    }

    return (
      <Fragment>
        {0 !== alerts.length && (
          <Fragment>
            {this.renderAlertNotice()}
            {this.renderAlertsCarousel()}
          </Fragment>
        )}
        {0 !== closings.length && (this.renderClosingsNotice())}
      </Fragment>
    );
  }
}

export default WeatherAlerts;
